import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from 'src/app/masters/master.service';
import * as CommonConstants from '../../utils/common.constants';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/utils/shared.service';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import swal from 'sweetalert2';
@Component({
  selector: 'app-administrative-file',
  templateUrl: './administrative-file.component.html',
  styleUrls: ['./administrative-file.component.scss']
})
export class AdministrativeFileComponent implements OnInit {

  languages = [];
  transferAcceptance: [];
  PARAM_KEY = [CommonConstants.TRANSFER_ACCEPTANCE, CommonConstants.DUTY, CommonConstants.MEDICAL_BACKGROUND,
  CommonConstants.COST_BEAR, CommonConstants.FOLLOWUP_CATEGORY, CommonConstants.ADMIN_FOLLOWUP_FROM,
  CommonConstants.ADMIN_FOLLOWUP_ANSWER_STATUS];
  MD_FILE_PARAM_KEY = [CommonConstants.MED_ADMIN_PAT_TRANSFER, CommonConstants.MED_ADMIN_COMPANION,
  CommonConstants.MED_ADMIN_FILE_FOLLOW];
  patTransferForm: FormGroup;
  adminCompanionForm: FormGroup;
  fuPatientForm: FormGroup;
  fuCompanionForm: FormGroup;
  medfiId;
  medAdminPatTransferList = [];
  companionNeedsList = [];
  patientNeedsList = [];
  companionList = [];
  duty = [];
  medBackground = [];
  costBear = [];
  followupCategories = [];
  answerStatus = [];
  followupFrom = [];
  typeFollowUpCompanion = CommonConstants.ADMIN_MED_FOLLOWUP_TYPE_COMPANION;
  typeFollowUpPatient = CommonConstants.ADMIN_MED_FOLLOWUP_TYPE_PATIENT;
  constructor(private modal: NgbModal, private masterService: MasterService, private formBuilder: FormBuilder,
    private sharedService: SharedService, private medicalFileService: MedicalFileService) { }

  ngOnInit() {
    this.loadMaster();
    this.getFormroup();
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medfiId = res;
      this.getMedicalFilesByKey();
    });
  }

  /**
  * Declare form group
  *
  */
  private getFormroup() {
    this.patTransferForm = this.formBuilder.group({
      'admpatrId': new FormControl(),
      'admpatrAssistFrom': ['', Validators.required],
      'admpatrRequestAssist': ['', Validators.email],
      'languCode1': new FormControl(),
      'languCode2': new FormControl(),
      'languCode3': new FormControl(),
      'medfiId': new FormControl(),
      'staRecCode': ['', Validators.required],
      'tracId': new FormControl()
    })
    this.adminCompanionForm = this.formBuilder.group({
      'admcoId': new FormControl(),
      'admcoCostBear': ['', Validators.required],
      'admcoLanguCode1': ['', Validators.email],
      'admcoLanguCode2': new FormControl(),
      'admcoLanguCode3': new FormControl(),
      'admcoMedicalBackground': new FormControl(),
      'admcoName': new FormControl(),
      'admcoRelationFunction': ['', Validators.required],
      'dutyId': new FormControl(),
      'medfiId': ['', Validators.required],
      'staRecCode': new FormControl()
    })

    this.fuPatientForm = this.formBuilder.group({
      'id': new FormControl(),
      'actionneeded': ['', Validators.required],
      'answerstatus': ['', Validators.email],
      'category': new FormControl(),
      'detail': new FormControl(),
      'dtCre': new FormControl(),
      'dtUpd': new FormControl(),
      'eDate': ['', Validators.required],
      'folloSecUsrId': new FormControl(),
      'medfiId': ['', Validators.required],
      'sDate': new FormControl(),
      'staRecCode': ['', Validators.required],
      'type': new FormControl(),
      'typeFollowUp': ['', Validators.required],
      'usrCre': new FormControl(),
      'usrUpd': new FormControl()
    })

    this.fuCompanionForm = this.formBuilder.group({
      'id': new FormControl(),
      'actionneeded': ['', Validators.required],
      'answerstatus': ['', Validators.email],
      'category': new FormControl(),
      'detail': new FormControl(),
      'dtCre': new FormControl(),
      'dtUpd': new FormControl(),
      'eDate': ['', Validators.required],
      'folloSecUsrId': new FormControl(),
      'medfiId': ['', Validators.required],
      'sDate': new FormControl(),
      'staRecCode': ['', Validators.required],
      'type': new FormControl(),
      'typeFollowUp': ['', Validators.required],
      'usrCre': new FormControl(),
      'usrUpd': new FormControl()
    })

  }
  /**
    * To get form controls
    */
  get tranF() { return this.patTransferForm.controls; }
  get cmpF() { return this.adminCompanionForm.controls; }
  get fuC() { return this.fuCompanionForm.controls; }
  get fuP() { return this.fuPatientForm.controls; }

  getMedicalFilesByKey() {
    this.medicalFileService.getMedicalFilesByKey(this.medfiId, this.MD_FILE_PARAM_KEY).subscribe(response => {
      let masterValues = response['result'];
      this.medAdminPatTransferList = masterValues[CommonConstants.MED_ADMIN_PAT_TRANSFER];
      this.medAdminPatTransferList = this.medAdminPatTransferList.map(item => ({
        ...item,
        languCodeName1: item.languCode1 ? this.languages.find(obj => obj.languageCode === item.languCode1).languageName : null,
        languCodeName2: item.languCode2 ? this.languages.find(obj => obj.languageCode === item.languCode2).languageName : null,
        languCodeName3: item.languCode3 ? this.languages.find(obj => obj.languageCode === item.languCode3).languageName : null,
      }));

      this.companionList= masterValues[CommonConstants.MED_ADMIN_COMPANION];
      this.companionList = this.companionList.map(item => ({
        ...item,
        languCodeName1: item.admcoLanguCode1 ? this.languages.find(obj => obj.languageCode === item.admcoLanguCode1).languageName : null,
        languCodeName2: item.admcoLanguCode2 ? this.languages.find(obj => obj.languageCode === item.admcoLanguCode2).languageName : null,
        languCodeName3: item.admcoLanguCode3 ? this.languages.find(obj => obj.languageCode === item.admcoLanguCode3).languageName : null,
        dutyValue: item.dutyId && item.dutyId != "" ? this.duty.find(obj => obj.id === +item.dutyId).value : null,
        admcoMedicalBackgroundValue: item.admcoMedicalBackground && item.admcoMedicalBackground != "" ? this.medBackground.find(obj => obj.id === +item.admcoMedicalBackground).value : null
      }));

      let followup =  masterValues[CommonConstants.MED_ADMIN_FILE_FOLLOW];
      this.companionNeedsList = followup.filter(item => item.type === this.typeFollowUpCompanion);
      this.companionNeedsList = this.companionNeedsList.map(item => ({
        ...item,
        catValue: item.category && item.category != "" ? this.followupCategories.find(obj => obj.id === +item.category).value : null,
        fromValue: item.folloSecUsrId && item.folloSecUsrId != "" ? this.followupFrom.find(obj => obj.id === +item.folloSecUsrId).value : null,
        answerStatusValue: item.answerStatus && item.answerStatus != "" ? this.followupFrom.find(obj => obj.id === +item.answerStatus).value : null
      }));

      this.patientNeedsList = followup.filter(item => item.type === this.typeFollowUpPatient);
      this.patientNeedsList = this.patientNeedsList.map(item => ({
        ...item,
        catValue: item.category && item.category != "" ? this.followupCategories.find(obj => obj.id === +item.category).value : null,
        fromValue: item.folloSecUsrId && item.folloSecUsrId != "" ? this.followupFrom.find(obj => obj.id === +item.folloSecUsrId).value : null,
        answerStatusValue: item.answerStatus && item.answerStatus != "" ? this.followupFrom.find(obj => obj.id === +item.answerStatus).value : null
      }));
    })
  }

  onTransferRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.tranF[name]) {
          if (name === "statuCode" || name === "languCode1" || name === "languCode2" || name === "languCode3") {
            this.tranF[name].patchValue(+obj.data[name]);
          } else {
            this.tranF[name].patchValue(obj.data[name]);
          }
        }
      });
    }
  }

  onComapanionRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.cmpF[name]) {
          if (name === "statuCode" || name==="admcoCostBear" || name==="medBackground" || name==="duty") {
            this.cmpF[name].patchValue(+obj.data[name]);
          } else {
            this.cmpF[name].patchValue(obj.data[name]);
          }
        }
      });
    }
  }

  onFollowupPatientNeedSelect(obj, modelId) {
    
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.fuP[name]) {
          if (name === "category" || name==="admcoCostBear" || name==="from" || name==="answerStatus") {
            this.fuP[name].patchValue(+obj.data[name]);
          } else {
            this.fuP[name].patchValue(obj.data[name]);
          }
        }
      });
    }
  }

  onFollowupCompanionNeedSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.fuC[name]) {
          if (name === "category" || name==="admcoCostBear" || name==="from" || name==="answerStatus") {
            this.fuC[name].patchValue(+obj.data[name]);
          } else {
            this.fuC[name].patchValue(obj.data[name]);
          }
        }
      });
    }
  }

  patientTransferAddModal(addPatientTransfer) {
    this.resetForm();
    this.modal.open(addPatientTransfer, { size: 'lg', container: '.page-content' });
  }
  companionAddModal(addCompanion) {
    this.resetForm();
    this.modal.open(addCompanion, { size: 'lg', container: '.page-content' });
  }
  patientNeedsAddModal(addPatientNeeds) {
    this.resetForm();
    this.modal.open(addPatientNeeds, { size: 'lg', container: '.page-content' });
  }
  companionNeedsAddModal(addCompanionNeeds) {
    this.resetForm();
    this.modal.open(addCompanionNeeds, { size: 'lg', container: '.page-content' });
  }

  loadMaster() {
    this.masterService.getLanguages().subscribe(res => {
      if (res && res["result"]) {
        this.languages = res["result"];
      }
    })

    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        let masterValues = response['result'];
        this.transferAcceptance = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_ACCEPTANCE);
        this.duty = masterValues.filter(master => master.paramKey === CommonConstants.DUTY);
        this.medBackground = masterValues.filter(master => master.paramKey === CommonConstants.MEDICAL_BACKGROUND);
        this.costBear = masterValues.filter(master => master.paramKey === CommonConstants.COST_BEAR);
        this.followupCategories = masterValues.filter(master => master.paramKey === CommonConstants.FOLLOWUP_CATEGORY);
        this.answerStatus= masterValues.filter(master => master.paramKey === CommonConstants.ADMIN_FOLLOWUP_ANSWER_STATUS);
        this.followupFrom= masterValues.filter(master => master.paramKey === CommonConstants.ADMIN_FOLLOWUP_FROM);
      }
    })
  }

  saveAdminPatientTransfer() {
    this.tranF.medfiId.setValue(this.medfiId);
    this.medicalFileService.saveAdminPatientTransfer(this.patTransferForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getMedicalFilesByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  saveCompanion() {
    this.cmpF.medfiId.setValue(this.medfiId);
    this.medicalFileService.saveAdminCompanion(this.adminCompanionForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getMedicalFilesByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  saveFollowUp(type) {

    let saveData;
    if (type && type === this.typeFollowUpCompanion) {
      this.fuCompanionForm.patchValue({
        medfiId: this.medfiId,
        type:this.typeFollowUpCompanion,
        eDate: this.fuC.eDate.value ? this.sharedService.getDateFormat(this.fuC.eDate.value) : null,
        sDate: this.fuC.sDate.value ? this.sharedService.getDateFormat(this.fuC.sDate.value) : null
      });
      saveData = this.fuCompanionForm.value;
    } else if (type && type === this.typeFollowUpPatient) {
      this.fuP.medfiId.setValue(this.medfiId);
      this.fuPatientForm.patchValue({
        medfiId: this.medfiId,
        type:this.typeFollowUpPatient,
        eDate: this.fuP.eDate.value ? this.sharedService.getDateFormat(this.fuP.eDate.value) : null,
        sDate: this.fuP.sDate.value ? this.sharedService.getDateFormat(this.fuP.sDate.value) : null
      });
      saveData = this.fuPatientForm.value;
    }
    this.medicalFileService.saveAdminFollowUp(saveData).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getMedicalFilesByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  resetForm(){
    this.fuPatientForm.reset();
    this.adminCompanionForm.reset();
    this.fuCompanionForm.reset();
    this.fuPatientForm.reset();
  }

}
